// src/redux/slices/authSlice.js
import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import axios from "axios";
import { ApiBaseUrl, chatDetailsClient } from "../../Utils/Constants";
import { toast } from "react-toastify";

export const hitGetChatDetailsClientApi = createAsyncThunk(
  "hitGetChatDetailsClientApi",
  async (payload) => {
    try {
      const config = {
        headers: {
          "Access-Control-Allow-Origin": "*",
          "Content-Type": "application/json",
          Authorization: `${localStorage.getItem("clientToken")}`,
        },
        params: payload,
      };
      const url = ApiBaseUrl + chatDetailsClient;
      const response = await axios.get(url, config);
      return response.data;
    } catch (error) {
      toast.error(error.response.data.message);
      throw error.response.data;
    }
  }
);

const GetChatDetailsClientSlice = createSlice({
  name: "getChatDetailsClientReducer",
  initialState: {
    isLoading: false,
    data: null,
  },
  reducers: {
    clearhitGetChatDetailsClientData: (state) => {
      state.data = null;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(hitGetChatDetailsClientApi.pending, (state) => {
        state.isLoading = true;
      })
      .addCase(hitGetChatDetailsClientApi.fulfilled, (state, action) => {
        state.isLoading = false;
        state.data = action.payload;
      })
      .addCase(hitGetChatDetailsClientApi.rejected, (state) => {
        state.isError = false;
      });
  },
});

export const { clearhitGetChatDetailsClientData } = GetChatDetailsClientSlice.actions;
export default GetChatDetailsClientSlice.reducer;
